"use client";
import { ConfigTypes } from "@/api/AppApi/common-interfaces/api-enums";
import { ICategories } from "@/api/AppApi/services/home/interfaces/ICategory";
import CategoryGrid from "./CategoryGrid";
import CategoryCarousel from "./CategoryCarousel";
import Separator from "../../lib/Separator";
import { carouselSpeed } from "@/utils/functions/functions";

interface Props extends ICategories {
  isSubCategory?: boolean;
  show_category_image: boolean;
  show_subcategory_image: boolean;
  text: {
    view_all: string;
  };
}

const Categories = (props: Props) => {
  const isSubCategory = props.isSubCategory;
  const { show_subcategory_image, show_category_image, text } = props;
  const showCatImage = isSubCategory
    ? show_subcategory_image
    : show_category_image;
  const speed = carouselSpeed(props.configurations?.customize?.interval);
  return (
    <>
      <Separator
        startLabel={props.configurations?.title!}
        endLabel={
          props.configurations?.view_all
            ? {
                label: text.view_all,
                href: props.configurations.target_url!,
              }
            : undefined
        }
      />
      {props.configurations?.type === ConfigTypes.grid ? (
        <CategoryGrid
          {...props}
          showCategoryImage={showCatImage!}
          isSubCategory={isSubCategory!}
        />
      ) : (
        <CategoryCarousel
          {...props}
          speed={speed}
          showCategoryImage={showCatImage!}
          isSubCategory={isSubCategory!}
        />
      )}
    </>
  );
};

export default Categories;
